import Icons from 'components/Icons'
import Heading from 'components/Typography/Header'
import Paragraph from 'components/Typography/Paragraph'
import { Zap, Shield, Smartphone, Sparkles } from 'lucide-react'

const Solutions = () => {
    return (
        <section className='py-24 md:py-40 relative overflow-hidden'>
            <div className='absolute inset-0 bg-gradient-to-br from-primary/5 via-transparent to-secondary/5'></div>
            
            <div className='max-w-7xl mx-auto px-6 relative z-10'>
                <div className='text-center space-y-10 mb-20'>
                    <div className='inline-flex items-center gap-3 px-4 py-2 bg-gradient-to-r from-primary/10 to-secondary/10 rounded-full border border-primary/20'>
                        <Icons className="bg-gradient-to-r from-primary to-secondary p-2 rounded-lg"> 
                            <Sparkles size={24} className="text-white" /> 
                        </Icons>
                        <span className="text-primary font-semibold text-sm">Dijital Hizmetlerimiz</span>
                    </div>

                    <div className='space-y-6'>
                        <Heading level={1} className="text-white text-5xl lg:text-6xl font-bold leading-tight bg-gradient-to-r from-white to-gray-300 bg-clip-text text-transparent">
                            Bigo Live, Oyun Kredileri ve<br />
                            <span className="bg-gradient-to-r from-primary to-secondary bg-clip-text text-transparent">Dijital Ödemeler</span>
                        </Heading>
                        <Paragraph className="text-gray-300 text-xl leading-relaxed max-w-3xl mx-auto">
                            SkyPay ile Bigo Live elmas, oyun kredileri, e-pin kodları ve tüm dijital ödeme ihtiyaçlarınızı güvenli ve hızlı bir şekilde karşılayın.
                        </Paragraph>
                    </div>
                </div>

                <div className='grid grid-cols-1 md:grid-cols-3 gap-8'>
                    <div className='group p-8 bg-gradient-to-br from-gray-900/80 to-gray-900/60 rounded-2xl border border-gray-700/50 backdrop-blur-sm hover:border-primary/30 transition-all duration-300 hover:transform hover:scale-105'>
                        <div className="relative mb-8">
                            <div className='w-20 h-20 bg-gradient-to-r from-primary to-secondary flex items-center justify-center rounded-2xl shadow-lg group-hover:shadow-primary/25 transition-all duration-300'>
                                <Zap size={40} className="text-white" />
                            </div>
                        </div>

                        <div className='space-y-6'>
                            <div className='space-y-3'>
                                <Heading level={3} className="text-white text-2xl font-bold group-hover:text-primary transition-colors duration-300">Bigo Live Elmas</Heading>
                                <Paragraph className="text-gray-300 leading-relaxed">
                                    Bigo Live elmaslarınızı anlık olarak satın alın. Hızlı teslimat ile canlı yayınlarınıza hemen başlayın ve takipçilerinizle etkileşime geçin.
                                </Paragraph>
                            </div>
                            <div className="flex flex-wrap gap-2">
                                <span className="inline-flex items-center px-3 py-1 rounded-full text-xs font-medium bg-primary/10 text-primary border border-primary/20">
                                    Anlık Teslimat
                                </span>
                                <span className="inline-flex items-center px-3 py-1 rounded-full text-xs font-medium bg-secondary/10 text-secondary border border-secondary/20">
                                    7/24 Destek
                                </span>
                            </div>
                        </div>
                    </div>

                    <div className='group p-8 bg-gradient-to-br from-gray-900/80 to-gray-900/60 rounded-2xl border border-gray-700/50 backdrop-blur-sm hover:border-secondary/30 transition-all duration-300 hover:transform hover:scale-105'>
                        <div className="relative mb-8">
                            <div className='w-20 h-20 bg-gradient-to-r from-secondary to-primary flex items-center justify-center rounded-2xl shadow-lg group-hover:shadow-secondary/25 transition-all duration-300'>
                                <Shield size={40} className="text-white" />
                            </div>
                            
                        </div>

                        <div className='space-y-6'>
                            <div className='space-y-3'>
                                <Heading level={3} className="text-white text-2xl font-bold group-hover:text-secondary transition-colors duration-300">Oyun Kredileri</Heading>
                                <Paragraph className="text-gray-300 leading-relaxed">
                                    Steam, PlayStation, Xbox, Google Play ve tüm popüler oyun platformları için kredileri güvenli şekilde satın alın.
                                </Paragraph>
                            </div>
                            <div className="flex flex-wrap gap-2">
                                <span className="inline-flex items-center px-3 py-1 rounded-full text-xs font-medium bg-secondary/10 text-secondary border border-secondary/20">
                                    Tüm Platformlar
                                </span>
                                <span className="inline-flex items-center px-3 py-1 rounded-full text-xs font-medium bg-primary/10 text-primary border border-primary/20">
                                    Güvenli
                                </span>
                            </div>
                        </div>
                    </div>

                    <div className='group p-8 bg-gradient-to-br from-gray-900/80 to-gray-900/60 rounded-2xl border border-gray-700/50 backdrop-blur-sm hover:border-primary/30 transition-all duration-300 hover:transform hover:scale-105'>
                        <div className="relative mb-8">
                            <div className='w-20 h-20 bg-gradient-to-r from-primary to-secondary flex items-center justify-center rounded-2xl shadow-lg group-hover:shadow-primary/25 transition-all duration-300'>
                                <Smartphone size={40} className="text-white" />
                            </div>
                        </div>

                        <div className='space-y-6'>
                            <div className='space-y-3'>
                                <Heading level={3} className="text-white text-2xl font-bold group-hover:text-primary transition-colors duration-300">Dijital Ödemeler</Heading>
                                <Paragraph className="text-gray-300 leading-relaxed">
                                    Tüm dijital ödeme ihtiyaçlarınız için hızlı, güvenli ve kolay çözüm. Mobil uyumlu platform ile her yerden erişim.
                                </Paragraph>
                            </div>
                            <div className="flex flex-wrap gap-2">
                                <span className="inline-flex items-center px-3 py-1 rounded-full text-xs font-medium bg-primary/10 text-primary border border-primary/20">
                                    Mobil Uyumlu
                                </span>
                                <span className="inline-flex items-center px-3 py-1 rounded-full text-xs font-medium bg-secondary/10 text-secondary border border-secondary/20">
                                    Hızlı
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default Solutions